import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import './Vendor.css'
import Location from './Location';
import { useDispatch, useSelector } from "react-redux";
import cal from '../.../../../images/cal1.png'
import { useParams } from 'react-router-dom';
import { emptyOneVen, loadOneVendor } from '../../Redux/Actions/ActionVendors';
import SinglePagenation from '../General/Pagination/SinglePagenation'

function VendorDetails() {
    let dispatch = useDispatch();
    const oneVendor = useSelector(state => state.vendorss.oneVendor)
    const loadingOneVendor = useSelector(state => state.vendorss.loadingOneVendor)
    const [pageNumber, setPageNumber] = useState(0);
    const [pageNumbersub, setpageNumbersub] = useState(0);
    const [pageNumberfea, setpageNumberfea] = useState(0);
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    let { id } = useParams()
    const [data, setData] = useState({})
    useEffect(() => {
        dispatch(loadOneVendor(id))
        return () => {
            dispatch(emptyOneVen());
        }
    }, [])
    useEffect(() => {
        setData(oneVendor)
    }, [oneVendor])

    const feaPerPage = 4;
    const pagesVisitedfea = pageNumberfea * feaPerPage;
    const displayfea = data.features ? data.features.slice(
        pagesVisitedfea,
        pagesVisitedfea + feaPerPage
    ) : [];

    const pageCountfea = data.features ? Math.ceil(data.features.length / feaPerPage) : 0;
    const changePagefea = ({ selected }) => {
        setpageNumberfea(selected);
    };

    const subPerPage = 4;
    const pagesVisitedSub = pageNumbersub * subPerPage;
    const displaysub = data.sub_categories ? data.sub_categories.slice(
        pagesVisitedSub,
        pagesVisitedSub + subPerPage
    ) : [];

    const pageCountsub = data.sub_categories ? Math.ceil(data.sub_categories.length / subPerPage) : 0;
    const changePagesub = ({ selected }) => {
        setpageNumbersub(selected);
    };

    const socialPerPage = 4;
    const pagesVisited = pageNumber * socialPerPage;
    const displaysocial = data.social_media ? data.social_media.slice(
        pagesVisited,
        pagesVisited + socialPerPage
    ) : [];

    const pageCount = data.social_media ? Math.ceil(data.social_media.length / socialPerPage) : 0;
    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };
    return (
        <main>
            <div className="page_header" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                <h2>{t('vendorDet')}</h2>
            </div>
            <div className='all_details' >
                <div className='top_info' >
                    <div className='main_info' >
                        <div className='main_info_top' >
                            <img src={data.image} />
                            <div className='inff' >
                                <h3>{data.name}</h3>
                                <p>
                                    <i className='fa fa-envelope' ></i>
                                    {data.email}
                                </p>
                                <p>
                                    <i className='fa fa-map-marker' ></i>
                                    {data.address}
                                </p>
                                <p>
                                    <i className='fa fa-phone' ></i>
                                    {data.phone}
                                </p>
                                {
                                    data.is_open == "0" ? (
                                        <p>
                                            <i className='fa fa-circle' ></i>
                                            close
                                        </p>
                                    ) : (
                                        <p>
                                            <i className='fa fa-circle' ></i>
                                            open
                                        </p>
                                    )
                                }
                                {
                                    data.is_active == "0" ? (
                                        <p>
                                            <i className='fa fa-circle' ></i>
                                            un active
                                        </p>
                                    ) : (
                                        <p>
                                            <i className='fa fa-circle' ></i>
                                            active
                                        </p>
                                    )
                                }

                            </div>
                        </div>
                        <div className='main_info_desc' >
                            {data.description}
                        </div>
                    </div>
                    <div className='map_info' >
                        {
                            data.latitude != null && data.longitude != null ? (
                                <Location latt={parseInt(data.latitude)} lngg={parseInt(data.longitude)} />
                            ) : <></>
                        }

                    </div>
                </div>
                <div className='div_dates' >
                    <div className='one_date' >
                        <div>
                            <div className='header_date' >
                                <h3>Start Date</h3>
                            </div>
                            <p>{data.start_date}</p>
                        </div>
                        <img src={cal} />
                    </div>
                    <div className='one_date' >
                        <div>
                            <div className='header_date' >
                                <h3>Expire Date</h3>
                            </div>
                            <p>{data.expire_date}</p>
                        </div>
                        <img src={cal} />
                    </div>
                    <div className='one_date' >
                        <div>
                            <div className='header_date' >
                                <h3>Custome Date</h3>
                            </div>
                            <p>{data.custom_date}</p>
                        </div>
                        <img src={cal} />
                    </div>
                </div>
                <div className='div_hours' >
                    {
                        data.days != undefined ? (
                            data.days.map((day) => {
                                return (
                                    <div className='one_day' >
                                        <div className='row_hour hour_color' >
                                            <i className='fa fa-calendar' ></i>
                                            <span className='name_day ' >Day: </span>
                                            <span >{day.name}</span>
                                        </div>
                                        <div className='row_hour' >
                                            <i className='fa fa-clock-o' ></i>
                                            <span className='name_day color_gray' >Open at:</span>
                                            <span className='color_gray' >{day.pivot.open_at}</span>
                                        </div>
                                        <div className='row_hour' >
                                            <i className='fa fa-clock-o' ></i>
                                            <span className='name_day color_gray' >Close at:</span>
                                            <span className='color_gray' >{day.pivot.close_at}</span>
                                        </div>
                                    </div>
                                )
                            })
                        ) : <></>

                    }
                </div>
                <div className='cat_vendor' >
                    <div className='div_cat' >
                    {/*<p>Package: {data.package_id}</p>*/}
                    </div><br></br>
                    <p className='div_sub' >Features: </p>
                    <div className='all_sub' >
                        {
                            displayfea.map((sub) => {
                                return (
                                    <div className='one_sub' >
                                        <img src={sub.icon} />
                                        <h4 className='color_gray' >{sub.name}</h4>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <SinglePagenation pageCount={pageCountsub} changePage={changePagesub} />
                </div>
                <div className='cat_vendor' >
                    <div className='div_cat' >
                        {
                            data.category != undefined ? (
                                <p>Category: {data.category.name}</p>
                            ) : <></>
                        }
                    </div><br></br>
                    <p className='div_sub' >SubCategory: </p>
                    <div className='all_sub' >
                        {
                            displaysub.map((sub) => {
                                return (
                                    <div className='one_sub' >
                                        <img src={sub.image} />
                                        <h4 className='color_gray' >{sub.name}</h4>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <SinglePagenation pageCount={pageCountsub} changePage={changePagesub} />
                </div>
                <div className='cat_vendor' >
                    <div className='div_cat' >
                        <p>Social Media</p>
                    </div><br></br>
                    <div className='all_sub' >
                        {
                            displaysocial.map((ss) => {
                                return (
                                    <a href={ss.pivot.link} className='one_sub'  >
                                        <img className='img_social' src={ss.image} />
                                        <h4 className='color_gray' >{ss.name}</h4>
                                    </a>
                                )
                            })
                        }
                    </div>
                    <SinglePagenation pageCount={pageCount} changePage={changePage} />
                </div>
            </div>
        </main>
    )
}

export default VendorDetails